// extracted by mini-css-extract-plugin
module.exports = {"form":"excuteDetailModal_form__3WD-9","total":"excuteDetailModal_total__3Onax"};